/**
 * @module lib/CrossTabUtils.js
 *
 * Utils for cross tab playback communication
 */

import once from 'lodash/once';

import * as CrosstabConstants from './constants';
import * as D from './deps';

const log = D.Logger.child({ component: 'domain/crosstab/utils' });

export const LsFields = Object.freeze({
  XTAB_ACTION: 'XTAB_ACTION',
  XTAB_CURRENTLY_PLAYING_TAB_ID: 'XTAB_CURRENTLY_PLAYING_TAB_ID',
});

export const receiveIncomingActions = once(store => {
  window.addEventListener('storage', event => {
    if (event.key === LsFields.XTAB_ACTION) {
      let action;
      try {
        action = JSON.parse(event.newValue);
        store.dispatch(action);
      } catch (e) {
        log.warn('Failed to parse JSON CrossTabUtils.XTAB_ACTION');
      }
    }
  });
});

export function sendAction(action) {
  localStorage.setItem(LsFields.XTAB_ACTION, JSON.stringify(action));
}

export function setCurrentlyPlayingTabId(tabId) {
  if (tabId) {
    localStorage.setItem(LsFields.XTAB_CURRENTLY_PLAYING_TAB_ID, tabId);
  } else {
    localStorage.removeItem(LsFields.XTAB_CURRENTLY_PLAYING_TAB_ID);
  }
}

export function getCurrentlyPlayingTabId() {
  return localStorage.getItem(LsFields.XTAB_CURRENTLY_PLAYING_TAB_ID);
}

/**
 * the current tab's tabId
 *
 * @param {object} state - redux state
 * @returns {boolean} true/false
 */
export function getMyTabId(state) {
  return state.crosstab.get(CrosstabConstants.CrossTabStateKeys.XTAB_MY_TAB_ID);
}

/**
 * Is this the currently playing tab?
 *
 * @param {object} state - redux state
 * @returns {boolean} true/false
 */
export function isCurrentlyPlayingTab(state) {
  const currentlyPlayingTabId = state.crosstab.get(
    CrosstabConstants.CrossTabStateKeys.XTAB_CURRENTLY_PLAYING_TAB_ID,
  );
  const myTabId = getMyTabId(state);
  return !currentlyPlayingTabId || myTabId === currentlyPlayingTabId;
}

export default {
  receiveIncomingActions,
  sendAction,
  setCurrentlyPlayingTabId,
  getCurrentlyPlayingTabId,
};
